import React, {useRef, useState, useLayoutEffect} from "react"
import {connect} from "react-redux";
import "./ContactUs.css"
import {mouseEnter, mouseLeave, setBlackHeader, toggleTopMenus} from "../actions/app";
import SnapStart from "../components/SnapStart";
import {useMediaQuery} from "react-responsive";
import {MobileBreakPoint} from "../constants";
import {Helmet} from 'react-helmet';


function ContactUs({footerHeight, bannerHeight, logoRatio, width, height}) {
  const [layoutReady, setLayoutReady] = useState(false)
  const [scrollIntoView, setScrollIntoView] = useState(true)
  const ref = useRef(null)
  const isDesktopOrLaptop = useMediaQuery({
    query: `(min-width: ${MobileBreakPoint + 1}px)`
  })
  const isTabletOrMobile = useMediaQuery({
    query: `(max-width: ${MobileBreakPoint}px)`
  })
  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      setLayoutReady(true)
    }, 250)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  return <div
    className={"ContactUs Content"}
    onMouseOver={() => {
      if (isDesktopOrLaptop && scrollIntoView && ref && ref.current) {
        ref.current.scrollIntoView(true, {behavior: "smooth"})
        setScrollIntoView(false)
      }
    }}
  >
    <Helmet>
      <title>mrdandy西装定制-mr.dandy高级定制 | 联系我们</title>
    </Helmet>
    {isDesktopOrLaptop && layoutReady && <SnapStart/>}
    {isDesktopOrLaptop &&
    <div style={{width: "100%", height: height - width * logoRatio - footerHeight - bannerHeight}}/>
    }
    {isDesktopOrLaptop && layoutReady && <SnapStart/>}
    <div ref={ref}/>
    {isDesktopOrLaptop &&
    <div
      style={{
        width: isDesktopOrLaptop ? "calc(100% - 50px)" : "100%",
        height: height - width * logoRatio - footerHeight - bannerHeight,
        backgroundImage: `url('/${width / height > 1440.0 / 900 ? "contact-us-cover.jpg" : "contact-us-cover-2.jpg"}')`,
        // backgroundImage: "url(/contact-us-cover.jpg)",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className={"CoverImage"}
    />}
    {!isDesktopOrLaptop &&
    <div
      style={{
        width: isDesktopOrLaptop ? "calc(100% - 50px)" : "100%",
        height: height - width * logoRatio - footerHeight - bannerHeight,
        backgroundImage: "url(/contact-us-cover-m.jpg)",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className={"CoverImage"}
    />}

    {isDesktopOrLaptop && <div style={{paddingBottom: 50}}/>}
    <div style={{
      width: isDesktopOrLaptop ? "calc(100% - 50px)" : "100%",
      paddingTop: isDesktopOrLaptop ? 0 : 64,
      paddingBottom: 100,
    }}>
      {isDesktopOrLaptop && layoutReady && <SnapStart/>}
      <div className={"Addresses"}>
        <div className={"LeftCol"}>
          <span className={"BerlingLtStdBold"}>
          ADDRESS <br/>
          </span>
          店铺地址
        </div>
        <div className={"RightCol"}>
          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                BEIJING<br/>
                </span>
                <span>
                北京店
                </span>
              </div>
              <div>


                <span className={"BerlingLtStdBold"}>
                NO. 103, XINGYUANHUI COMMERCE-SUBJACENT,<br/>
                <span className={"BerlingLtStdBold"}>
                </span>
                 NO. 63 XINYUAN STREET, CHAOYANG DISTRICT,  <br/>
                <span className={"BerlingLtStdBold"}>
                </span>
                 BEIJING, CHINA <br/>
                </span>
                北京市朝阳区新源街63号底商103
              </div>
            </div>
            <div><img src={"/beijing.svg"}/></div>
          </div>
          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                SHANGHAI<br/>
                </span>
                上海店
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                5F, WALDORF DOLLAR BUILDING,<br/>
                NO.51, GUANGDONG ROAD, HUANGPU DISTRICT, <br/>
                SHANGHAI, CHINA<br/>
                </span>
                上海市黄浦区广东路51号华尔道夫大来大楼5F
              </div>
            </div>
            <div><img src={"/shanghai.png"}/></div>
          </div>
          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                SHENZHEN<br/>
                </span>
                深圳店
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                  SOUTH SIDE OF MARRIOTT EXECUTIVE APARTMENTS,<br/>
                  SHAHE STREET, NANSHAN DISTRICT,<br/>
                  SHENZHEN, GUANGDONG<br/>
                </span>
                广东省深圳市南山区沙河街道万豪行政酒店公寓南侧
              </div>
            </div>
            <div><img src={"/shenzhen.svg"}/></div>
          </div>
          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                WUHAN<br/>
                </span>
                武汉店
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                604 WUHAN WANDA CENTER, <br/>
                NO. 96 LINJIANG ROAD, JIYU BRIDGE STREET,  <br/>
                WUCHANG DISTRICT, WUHAN, CHINA<br/>
                </span>
                湖北省武汉市武昌区积玉桥街临江大道96号武汉万达中心604
              </div>
            </div>
            <div><img src={"/wuhan.svg"}/></div>
          </div>
          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                ZHENGZHOU<br/>
                </span>
                郑州店
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                  ROOM 503,BUILDING E,<br/>
                  JIANYE HEADQUARTERS PORT,<br/>
                  RUYI WEST ROAD, ZHENGZHOU,<br/>
                  HENAN PROVINCE<br/>
                </span>
                郑州市如意西路建业总部港E座503
              </div>
            </div>
            <div><img src={"/zhengzhou.svg"}/></div>
          </div>
          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                HANGZHOU<br/>
                </span>
                杭州店
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                  BUILDING 4,NO.90 CHENGXING ROAD,<br/>
                  SHANGCHENG DISTRICT,<br/>
                  HANGZHOU,ZHEJIANG <br/>
                </span>
                浙江省杭州市上城区城星路90号4幢
              </div>
            </div>
            <div><img src={"/hangzhou.svg"}/></div>
          </div>

          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                NANJING<br/>
                </span>
                南京店
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                  RM102, T1 ATLAS,<br/>
                  NO. 318, LUSHAN RD,<br/>
                  JIANYE DISTRICT, NANJING, JIANGSU <br/>
                </span>
                江苏省南京市建邺区庐山路318号1幢翎寓底商102室
              </div>
            </div>
            <div><img src={"/nanjing.svg"}/></div>
          </div>

          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                XI'AN<br/>
                </span>
                西安店
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                  11-101 & 201, BLOCK A, QUJIANG LIUGUANGLI,<br/>
                  1555 YANXIANG ROAD, QUJIANG NEW DISTRICT,<br/>
                  XI'AN, SHAANXI<br/>
                </span>
                陕西省西安市曲江新区雁翔路1555号曲江流光里A区11-101&201
              </div>
            </div>
            <div><img src={"/xian.svg"}/></div>
          </div>

          <div className={"AddressRow"}>
            <div>
              <div>
                <span className={"BerlingLtStdBold"}>
                CHENGDU<br/>
                </span>
                成都店
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                  SHOP T5, JIAOZIFANGYUAN, <br/>
                  SHIYANG SUBDISTRICT,  <br/>
                  WUHOU DISTRICT, <br />
                  CHENGDU, SICHUAN<br/>
                </span>
                四川省成都市武侯区石羊街道交子方圆 T5 商铺
              </div>
            </div>
            <div><img src={"/chengdu.svg"}/></div>
          </div>


        </div>
      </div>
      {isDesktopOrLaptop && layoutReady && <SnapStart/>}
      <div className={"ContactList"}>
        <div className={"LeftCol"}>
                <span className={"BerlingLtStdBold"}>
          CONTACT<br/>
                </span>
          联系方式
        </div>
        <div className={"RightCol"}>
          <div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                TELEPHONE<br/>
                </span>
                全国统一客服电话
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                400-886-5786
                </span>
              </div>
            </div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                WECHAT ID<br/>
                </span>
                全国统一客服微信
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
              mrdandyservice
                </span>
              </div>
            </div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                E-MAIL<br/>
                </span>
                邮箱
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                huzhen@mrdandy.com.cn
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*{isDesktopOrLaptop && layoutReady && <SnapStart/>}*/}
      <div className={"ContactList"}>
        <div className={"LeftCol"}>
                <span className={"BerlingLtStdBold"}>
          SOCIAL MEDIA<br/>
                </span>
          官方媒体
        </div>
        <div className={"RightCol"}>
          <div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                INSTAGRAM
                </span>
              </div>
              <div>
                <span className={"BerlingLtStdBold"}>
                mrdandybespoke
                </span>
              </div>
            </div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                WEIBO<br/>
                </span>
                新浪微博
              </div>
              <div>
                <span className={"BerlingLtStdBold"}
                      style={{verticalAlign: "middle"}}
                >
                MrDandy
                </span>官方微博
              </div>
            </div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                WECHAT PUBLIC<br/> ACCOUNTS<br/>
                </span>
                微信公众号
              </div>
              <div><img src={"/微信二维码.svg"}/></div>
            </div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                TIK TOK<br/>
                </span>
                抖音
              </div>
              <div>
                <span className={"BerlingLtStdBold"}
                      style={{verticalAlign: "middle"}}
                >
                Mr.Dandy
                </span>胡榛
              </div>
            </div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                BILIBILI<br/>
                </span>
              </div>
              <div>
                <span className={"BerlingLtStdBold"}
                      style={{verticalAlign: "middle"}}
                >
                MrDandy
                </span>胡榛
              </div>
            </div>
            <div className={"ContactRow"}>
              <div>
                <span className={"BerlingLtStdBold"}>
                XIAOHONGSHU<br/>
                </span>
                小红书
              </div>
              <div>
                <span className={"BerlingLtStdBold"}
                      style={{verticalAlign: "middle"}}
                >
                Mr. Dandy
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

const mapStateToProps = (state, ownProps) => {
  return {
    pathname: state.router.location.pathname,
    width: state.app.width,
    height: state.app.height,
    footerHeight: state.app.footerHeight,
    bannerHeight: state.app.bannerHeight,
    logoRatio: state.app.logoRatio,
    openTopMenus: state.app.openTopMenus,
    blackHeader: state.app.blackHeader,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleTopMenus: () => dispatch(toggleTopMenus()),
    mouseEnter: () => dispatch(mouseEnter()),
    mouseLeave: () => dispatch(mouseLeave()),
    setBlackHeader: (isBlack) => dispatch(setBlackHeader(isBlack))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
